import { createListenerMiddleware } from '@reduxjs/toolkit';
import { formatDate, sortingHelper, Filters } from '@ui/src';
import {
  getLogs,
  getLogsSuccess,
} from '../hoc/tariffs/store/slices/tariff-page';
import { TariffLog } from '../hoc/tariffs/types';
import {
  getTransaction,
  getTransactionSuccess,
  chargeback,
  chargebackSuccess,
  fraud,
  fraudSuccess,
} from '../hoc/cards/store/slices/transaction';
import {
  getCards as getCardsItem,
  getCardsSuccess as getCardsItemSuccess,
  getUser,
  getUserSuccess,
  changeStatus as changeStatusItem,
  getTransactions,
  getTransactionsSuccess,
  onSortTransactions,
  onSortTransactionsSuccess,
  onFilterTransactions,
  onFilterTransactionsSuccess,
  onSubmitCard,
  onSubmitCardSuccess,
  changeStatusSuccess as changeStatusItemSuccess,
  getCardInfo,
  getCardInfoSuccess,
} from '../hoc/cards/store/slices/item';
import {
  Transaction,
  TransactionDescription,
  Card,
  CardStatus,
} from '../hoc/cards/types';
import { ConfigurationRootState } from './state';
import transactionFiltersHelper from '../hoc/cards/helpers/transactions-filters-helper';
import getCardAvailableStatuses from '../hoc/cards/helpers/get-card-available-statuses';
import {
  getCards,
  getCardsSuccess,
  changeStatus,
  changeStatusSuccess,
  onSortListSuccess,
  onSortList,
  onFilterList,
  onFilterListSuccess,
} from '../hoc/cards/store/slices/list';
import filtersHelper from '../hoc/cards/helpers/filters-helper';

const logsMock: TariffLog[] = [
  {
    id: 'uuid-1',
    action: 'Add fee Transaction fee',
    user: 'Christian Evans',
    date: new Date('2021-01-28').toISOString(),
  },
  {
    id: 'uuid-2',
    action: 'Add fee HighBalance 1000',
    user: 'Christian Evans',
    date: new Date('2021-01-28').toISOString(),
  },
  {
    id: 'uuid-3',
    action: 'Remove fee',
    user: 'Christian Evans',
    date: new Date('2021-01-28').toISOString(),
  },
  {
    id: 'uuid-4',
    action: 'Add fee HighBalance 2000',
    user: 'Christian Evans',
    date: new Date('2021-01-28').toISOString(),
  },
];

const transactionMock: Transaction = {
  id: 'uuid-1',
  date: new Date().toISOString(),
  description: TransactionDescription.CHARGEBACK,
  currency: 'eur',
  bc: 'eur',
  amount: '345.00',
  terminalId: 'Amazon FR',
  amountBc: '296.27',
  merchantName: 'Five guys',
  orderDetails: 'XID0900123',
};

const cardsListMock: Card[] = [
  {
    id: 'uuid-1',
    customer: 'John Smith',
    account: '3.0.00.000001',
    cardType: 'debit',
    paymentSystem: 'MC',
    pan: '*8788',
    status: CardStatus.NEW,
    balance: '0',
    virtual: false,
  },
  {
    id: 'uuid-2',
    customer: 'John Smith',
    account: '3.0.00.000001',
    cardType: 'debit',
    paymentSystem: 'MC',
    pan: '*8322',
    status: CardStatus.NEW,
    balance: '0',
    virtual: true,
  },
  {
    id: 'uuid-3',
    customer: 'John Smith',
    account: '3.0.00.000001',
    cardType: 'debit',
    paymentSystem: 'MC',
    pan: '*3448',
    status: CardStatus.NEW,
    balance: '0',
    virtual: false,
  },
  {
    id: 'uuid-4',
    customer: 'John Smith',
    account: '3.0.00.000001',
    cardType: 'debit',
    paymentSystem: 'MC',
    pan: '*5885',
    status: CardStatus.NEW,
    balance: '0',
    virtual: false,
  },
  {
    id: 'uuid-5',
    customer: 'John Lennon',
    account: '3.0.00.000111',
    cardType: 'debit',
    paymentSystem: 'Visa',
    pan: '*5056',
    status: CardStatus.ORDERED,
    balance: '0',
    virtual: false,
  },
  {
    id: 'uuid-6',
    customer: 'Ted Baker',
    account: '3.0.00.000033',
    cardType: 'debit',
    paymentSystem: 'MC',
    pan: '*7788',
    status: CardStatus.FROZEN,
    balance: '30',
    virtual: false,
  },
  {
    id: 'uuid-7',
    customer: 'Jack Sparrow',
    account: '3.0.00.050074',
    cardType: 'credit',
    paymentSystem: 'MC',
    pan: '*8778',
    status: CardStatus.FROZEN,
    balance: '135.66',
    virtual: true,
  },
  {
    id: 'uuid-8',
    customer: 'Peter Jones',
    account: '3.0.00.000346',
    cardType: 'credit',
    paymentSystem: 'Visa',
    pan: '*1125',
    status: CardStatus.CANCELED,
    balance: '0',
    virtual: false,
  },
  {
    id: 'uuid-9',
    customer: 'Paul Hewston',
    account: '3.0.00.000346',
    cardType: 'credit',
    paymentSystem: 'Visa',
    pan: '*3555',
    status: CardStatus.VOID,
    balance: '0',
    virtual: false,
  },
];

const cardsMock: Card[] = [
  {
    id: 'uuid-1',
    customer: 'John Smith',
    account: '3.0.00.000001',
    cardType: 'debit',
    paymentSystem: 'MC',
    pan: '*8478',
    status: CardStatus.ACTIVE,
    balance: '135.66',
    currency: 'eur',
    expairedDate: new Date('2029-07-01').toISOString(),
    address: 'United Kingdom, London Apt. 203, 23 Baker street W1 5DE',
    type: 'corporate',
  },
  {
    id: 'uuid-2',
    customer: 'John Smith',
    account: '3.0.00.000001',
    cardType: 'debit',
    paymentSystem: 'Visa',
    pan: '*8788',
    status: CardStatus.ACTIVE,
    balance: '135.66',
    currency: 'eur',
    expairedDate: new Date('2029-07-01').toISOString(),
    address: 'United Kingdom, London Apt. 203, 23 Baker street W1 5DE',
    type: 'individual',
  },
  {
    id: 'uuid-3',
    customer: 'John Smith',
    account: '3.0.00.000001',
    cardType: 'debit',
    paymentSystem: 'Visa',
    pan: '*8788',
    status: CardStatus.ORDERED,
    balance: '135.66',
    currency: 'eur',
    expairedDate: new Date('2029-07-01').toISOString(),
    address: 'United Kingdom, London Apt. 203, 23 Baker street W1 5DE',
    type: 'individual',
    virtual: true,
  },
  {
    id: 'uuid-4',
    paymentSystem: 'Visa',
    pan: '**57 8478',
    cardType: 'debit',
    expairedDate: new Date('2028-01-04').toISOString(),
    balance: '587.54',
    currency: 'eur',
    status: CardStatus.VOID,
    account: '3.0.00.000001',
    address: 'United Kingdom, London, Apt. 203, 23, Baker street, W1 5DE',
    customer: 'John Smith',
  },
];

const transactionsMock: Transaction[] = [
  {
    id: 'uuid-1',
    date: new Date().toISOString(),
    description: TransactionDescription.CHARGEBACK,
    currency: 'eur',
    amount: '345.00',
    terminalId: 'Amazon FR',
    amountBc: '296.27',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-2',
    date: new Date().toISOString(),
    description: TransactionDescription.CREDIT,
    currency: 'eur',
    amount: '38.00',
    terminalId: 'Amazon FR',
    amountBc: '32.63',
    merchantName: 'Five guys',
    orderDetails: '448-89808',
  },
  {
    id: 'uuid-3',
    date: new Date().toISOString(),
    description: TransactionDescription.CREDIT,
    currency: 'eur',
    amount: '117.50',
    terminalId: 'Amazon FR',
    amountBc: '100.91',
    merchantName: 'Five guys',
    orderDetails: '55874108/898',
  },
  {
    id: 'uuid-4',
    date: new Date().toISOString(),
    description: TransactionDescription.VOID,
    currency: 'eur',
    amount: '-48.00',
    terminalId: 'Amazon FR',
    amountBc: '-100.92',
    merchantName: 'Order 78881-1',
    orderDetails: 'XID0900125',
  },
  {
    id: 'uuid-5',
    date: new Date().toISOString(),
    description: TransactionDescription.DEBIT,
    currency: 'eur',
    amount: '-48.00',
    terminalId: 'Amazon FR',
    amountBc: '-41.22',
    merchantName: 'Five guys',
    orderDetails: 'Order35532',
  },
  {
    id: 'uuid-6',
    date: new Date().toISOString(),
    description: TransactionDescription.REFUND,
    currency: 'eur',
    amount: '-345.00',
    terminalId: 'Amazon FR',
    amountBc: '-296.27',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-7',
    date: new Date().toISOString(),
    description: TransactionDescription.DEBIT,
    currency: 'eur',
    amount: '-38.00',
    terminalId: 'Amazon FR',
    amountBc: '-32.63',
    merchantName: 'Five guys',
    orderDetails: 'XID0900162',
  },
  {
    id: 'uuid-8',
    date: new Date().toISOString(),
    description: TransactionDescription.DEBIT,
    currency: 'eur',
    amount: '-38.00',
    terminalId: 'Amazon FR',
    amountBc: '-32.63',
    merchantName: 'Five guys',
    orderDetails: 'XID0900166',
    fraud: true,
  },
  {
    id: 'uuid-9',
    date: new Date().toISOString(),
    description: TransactionDescription.CREDIT,
    currency: 'eur',
    amount: '345.00',
    merchantName: 'Five guys',
    terminalId: 'Amazon FR',
    amountBc: '-41.22',
    orderDetails: 'XID0900153',
  },
  {
    id: 'uuid-10',
    date: new Date().toISOString(),
    description: TransactionDescription.CHARGEBACK,
    currency: 'eur',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900133',
    terminalId: 'Amazon FR',
    amountBc: '200.01',
  },
  {
    id: 'uuid-11',
    date: new Date().toISOString(),
    description: TransactionDescription.REFUND,
    currency: 'eur',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900133',
    terminalId: 'Amazon FR',
    amountBc: '200.01',
  },
];

const configurationMiddleware = createListenerMiddleware();

configurationMiddleware.startListening({
  actionCreator: getLogs,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(
        getLogsSuccess(
          logsMock.map((item) => ({
            ...item,
            date: formatDate(item.date, true),
          })),
        ),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: getTransaction,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(getTransactionSuccess(transactionMock));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: chargeback,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        item: {
          transactions: { values, filters, sort },
        },
        transaction: { transactionId },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    let nextTrancastions = values?.map((item) => {
      const result = { ...item };

      if (transactionId === result.id) {
        result.description = TransactionDescription.CHARGEBACK;
      }

      return result;
    });

    if (!filters && sort) {
      nextTrancastions = sortingHelper<Transaction>(
        nextTrancastions as Transaction[],
        sort.sortProp,
        sort.sortDir as 'asc' | 'desc',
      );
    } else if (filters) {
      nextTrancastions = transactionFiltersHelper(
        nextTrancastions as Transaction[],
        sort?.sortProp as string,
        sort?.sortDir as 'asc' | 'desc',
        filters,
      );
    }

    setTimeout(() => {
      listenerApi.dispatch(
        getTransactionsSuccess(nextTrancastions as Transaction[]),
      );
      listenerApi.dispatch(chargebackSuccess());
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: fraud,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        item: {
          transactions: { values, filters, sort },
        },
        transaction: { transactionId },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    let nextTrancastions = values?.map((item) => {
      const result = { ...item };

      if (transactionId === result.id) {
        result.fraud = true;
      }

      return result;
    });

    if (!filters && sort) {
      nextTrancastions = sortingHelper<Transaction>(
        nextTrancastions as Transaction[],
        sort.sortProp,
        sort.sortDir as 'asc' | 'desc',
      );
    } else if (filters) {
      nextTrancastions = transactionFiltersHelper(
        nextTrancastions as Transaction[],
        sort?.sortProp as string,
        sort?.sortDir as 'asc' | 'desc',
        filters,
      );
    }

    setTimeout(() => {
      listenerApi.dispatch(
        getTransactionsSuccess(nextTrancastions as Transaction[]),
      );
      listenerApi.dispatch(fraudSuccess());
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: getCards,
  effect: async (action, listenerApi) => {
    let nextList: Card[] = [];

    if (action.payload) {
      if (
        action.payload.name &&
        action.payload.direction &&
        !action.payload.filters
      ) {
        nextList = sortingHelper<Card>(
          cardsListMock,
          action.payload.name,
          action.payload.direction,
        );
      }

      if (action.payload.filters) {
        const nextFilters: Filters = {};

        Object.keys(action.payload.filters).forEach((key) => {
          if (
            (action?.payload?.filters as Filters)[key] &&
            (action.payload.filters as Filters)[key].value.length < 2
          ) {
            nextFilters[key] = {
              ...nextFilters[key],
              value: [(action.payload.filters as Filters)[key].value.join()],
            };
          } else {
            nextFilters[key] = (action?.payload?.filters as Filters)[key];
          }
        });

        nextList = filtersHelper(
          cardsListMock,
          action.payload?.name as string,
          action.payload?.direction as 'asc' | 'desc',
          nextFilters,
        );
      }
    }

    setTimeout(() => {
      listenerApi.dispatch(getCardsSuccess(nextList));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: onSortList,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        list: { values },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    if (values) {
      const nextStatements = sortingHelper<Card>(
        [...values],
        action.payload.name,
        action.payload.direction,
      );

      setTimeout(() => {
        listenerApi.dispatch(onSortListSuccess(nextStatements));
        listenerApi.cancelActiveListeners();
      }, 1000);
    }
  },
});

configurationMiddleware.startListening({
  actionCreator: onFilterList,
  effect: async (action, listenerApi) => {
    const {
      bankAndPsp: {
        list: { sort },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    const nextFilters: Filters = {};

    Object.keys(action.payload).forEach((key) => {
      if (action.payload[key] && action.payload[key].value.length < 2) {
        nextFilters[key] = {
          ...nextFilters[key],
          value: [action.payload[key].value.join()],
        };
      } else {
        nextFilters[key] = action.payload[key];
      }
    });

    const nextStatements = filtersHelper(
      cardsListMock,
      sort?.sortProp as string,
      sort?.sortDir as 'asc' | 'desc',
      nextFilters,
    );

    setTimeout(() => {
      listenerApi.dispatch(onFilterListSuccess(nextStatements));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: changeStatus,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        list: { values, selectedList },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    const nextList = values?.map((item) => {
      const result = { ...item };

      if (selectedList.find((selected) => selected === result.id)) {
        result.status = action.payload;
      }

      return result;
    });

    setTimeout(() => {
      listenerApi.dispatch(changeStatusSuccess(nextList as Card[]));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: getUser,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(
        getUserSuccess({
          id: '67972ebe-b992-4dfe-b3fe-c504e7540c6d',
          firstName: 'James',
          lastName: 'Cook',
        }),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: getCardInfo,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        item: {
          cards: { values },
          cardEditId,
        },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    const currentCard = values?.find((item) => item.id === cardEditId);

    setTimeout(() => {
      listenerApi.dispatch(getCardInfoSuccess(currentCard as Card));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: onSubmitCard,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        item: {
          cards: { values },
          orderCardFormValues,
        },
        list: { values: cardsValues },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    const nextCards = ([] as Card[]).concat(values as Card[]);

    let card: Card = {
      id: `uuid-${nextCards.length + 1}`,
      paymentSystem: orderCardFormValues?.paymentSystem as string,
      pan: '**57 8478',
      cardType: 'debit',
      expairedDate: new Date('2028-01-04').toISOString(),
      currency: 'eur',
      status: CardStatus.ORDERED,
      account: '3.0.00.000001',
      address: '',
      customer: 'John Smith',
      availableStatuses: getCardAvailableStatuses(CardStatus.ORDERED),
      virtual: !orderCardFormValues?.physical,
    };

    if (orderCardFormValues?.physical) {
      card = {
        ...card,
        address: `${orderCardFormValues.countryName}, ${orderCardFormValues.city}, ${orderCardFormValues.apartment}, ${orderCardFormValues.street}, ${orderCardFormValues.postCode}`,
        countryId: orderCardFormValues?.countryId,
        city: orderCardFormValues?.city,
        postCode: orderCardFormValues?.postCode,
        street: orderCardFormValues?.street,
        apartment: orderCardFormValues?.apartment,
      };
    }

    nextCards.push(card);

    setTimeout(() => {
      listenerApi.dispatch(onSubmitCardSuccess(nextCards));

      if (cardsValues) {
        let nextCardsValues: Card[] = [];

        if (cardsValues.length > 0) {
          nextCardsValues = ([] as Card[]).concat(cardsValues);
        }

        nextCardsValues.push({
          id: `uuid-${nextCardsValues.length + 1}`,
          customer: 'John Smith',
          account: '3.0.00.000001',
          cardType: 'debit',
          paymentSystem: orderCardFormValues?.paymentSystem as string,
          pan: '*8788',
          status: CardStatus.ORDERED,
          balance: '0',
          virtual: !orderCardFormValues?.physical,
        });

        listenerApi.dispatch(getCardsSuccess(nextCardsValues));
      }
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: getCardsItem,
  effect: async (action, listenerApi) => {
    const nextCards = cardsMock.map((item) => {
      const result = { ...item };

      result.availableStatuses = getCardAvailableStatuses(item.status);

      return result;
    });

    setTimeout(() => {
      listenerApi.dispatch(getCardsItemSuccess(nextCards));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: changeStatusItem,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        item: {
          cards: { values },
          statusFormValues,
        },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    const nextCards = values?.map((card) => {
      const result = { ...card };

      if (result.id === statusFormValues?.cardId) {
        result.status = statusFormValues.status;
      }

      return result;
    });

    setTimeout(() => {
      listenerApi.dispatch(changeStatusItemSuccess(nextCards as Card[]));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: getTransactions,
  effect: async (action, listenerApi) => {
    let nextList: Transaction[] = transactionsMock;

    if (action.payload) {
      if (
        action.payload.name &&
        action.payload.direction &&
        !action.payload.filters
      ) {
        nextList = sortingHelper<Transaction>(
          transactionsMock,
          action.payload.name,
          action.payload.direction,
        );
      }

      if (action.payload.filters) {
        const nextFilters: Filters = {};

        Object.keys(action.payload.filters).forEach((key) => {
          if (
            (action?.payload?.filters as Filters)[key] &&
            (action.payload.filters as Filters)[key].value.length < 2
          ) {
            nextFilters[key] = {
              ...nextFilters[key],
              value: [(action.payload.filters as Filters)[key].value.join()],
            };
          } else {
            nextFilters[key] = (action?.payload?.filters as Filters)[key];
          }
        });

        nextList = transactionFiltersHelper(
          transactionsMock,
          action.payload?.name as string,
          action.payload?.direction as 'asc' | 'desc',
          nextFilters,
        );
      }
    }

    setTimeout(() => {
      listenerApi.dispatch(getTransactionsSuccess(nextList));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

configurationMiddleware.startListening({
  actionCreator: onSortTransactions,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        item: {
          transactions: { values },
        },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    if (values) {
      const nextTransactions = sortingHelper<Transaction>(
        [...values],
        action.payload.name,
        action.payload.direction,
      );

      setTimeout(() => {
        listenerApi.dispatch(onSortTransactionsSuccess(nextTransactions));
        listenerApi.cancelActiveListeners();
      }, 1000);
    }
  },
});

configurationMiddleware.startListening({
  actionCreator: onFilterTransactions,
  effect: async (action, listenerApi) => {
    const {
      cards: {
        item: {
          transactions: { sort },
        },
      },
    } = listenerApi.getState() as ConfigurationRootState;

    const nextFilters: Filters = {};

    Object.keys(action.payload).forEach((key) => {
      if (action.payload[key] && action.payload[key].value.length < 2) {
        nextFilters[key] = {
          ...nextFilters[key],
          value: [action.payload[key].value.join()],
        };
      } else {
        nextFilters[key] = action.payload[key];
      }
    });

    const nextTrancastions = transactionFiltersHelper(
      transactionsMock,
      sort?.sortProp as string,
      sort?.sortDir as 'asc' | 'desc',
      nextFilters,
    );

    setTimeout(() => {
      listenerApi.dispatch(onFilterTransactionsSuccess(nextTrancastions));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

export default configurationMiddleware;
